import { useEffect } from 'react';
import api from '@/lib/api';

export const YOUTUBE_ACCOUNT_EVENT = 'twinnee:youtube-account';

export function emitYouTubeAccountChange() {
  window.dispatchEvent(new Event(YOUTUBE_ACCOUNT_EVENT));
}

export function subscribeYouTubeAccount(handler) {
  window.addEventListener(YOUTUBE_ACCOUNT_EVENT, handler);
  return () => window.removeEventListener(YOUTUBE_ACCOUNT_EVENT, handler);
}

export function useYouTubeAccountReset(handler) {
  useEffect(() => subscribeYouTubeAccount(handler), [handler]);
}

/** Remove the YouTube login and tell every open page to drop the old channel. */
export async function disconnectYouTube() {
  await api.delete('/social-publish/youtube/disconnect');
  emitYouTubeAccountChange();
}
